export const DUTY_LAWYER_USERNAME = "duty.lawyer";

/**
 * Wagtail role slugs surfaced on `UserProfile.roles` (OBS-1415). These match the
 * slugified group names old Wagtail sends, so gate features with `useHasRole`.
 */
export const Role = {
  PICTURE_EDITOR: "picture-editors",
} as const;

export type Role = (typeof Role)[keyof typeof Role];
